/* import __COLOCATED_TEMPLATE__ from './payee-verification.hbs'; */
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-payout-payee-verification';

export default Component.extend({
  classNames: [CLASS_NAME, 'LSG-l-grid', 'justify-center'],
  CLASS_NAME,

  /** @param {HyperwalletUser|null} */
  hyperwalletUser: null,

  /** @param {Boolean} */
  isLoading: false,

  /** @param {String} */
  scriptHost: '',

  /** @param {Function} */
  getAuthToken: () => {},

  /** @param {Function} */
  onSubmitSuccess: () => {},

  actions: {
    handleGetAuthToken() {
      return this.get('getAuthToken')();
    },

    handleSubmitSuccess() {
      this.get('onSubmitSuccess')();
    },
  },
});
